export default __webpack_public_path__ + "static/media/bxs_error.d404ec83.svg";